import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler } from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon } from "react-bootstrap";
import Highlight from "react-highlight";
import { Navigation, Link } from "react-router";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import UserHandler from "js/utilities/user-handler";
import { ZOOM_ICON } from "js/config.jsx";
import SDKSidebar from "js/utilities/sdk-sidebar"

export default React.createClass({
  displayName: "photo-id-match-guide",
  scrollToGuide: null,
  scrollingEl: null,
  getInitialState: function () {
    var data = [{ name: "Photo ID Match Guide" }
    ];

    var scrollToElement = initDeepLinkData(this.props);

    return {
      data,
      navMenuParent: null,
      navMenu: null,
      android_release_version: "",
      android_release_date: "",
      ios_release_version: "",
      ios_release_date: "",
      server_java_release_version: "",
      server_java_release_date: "",
      server_c_release_version: "",
      server_c_release_date: "",
      zoom_web_release_version: "",
      zoom_web_release_date: "",
      scrollToElement: scrollToElement,
      isMobile: false
    };
  },

  componentDidMount: function () {
    mountCode(this);
    this.setState({isMobile: window.innerWidth <= 760});
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function () {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container">

              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="photo-id-match-guide">Photo ID Match Guide</h2>
                </div>
                <p>Learn about performing Certified Liveness Detection & Matching the 3D Face of the Live user to their 2D Photo ID Document.</p>
                <hr/>
              </section>
              <section>
                <div className="row">
                  <div className={this.state.isMobile == true? "col-xs-12" : "col-xs-7"}>
                    <h3 id="introduction-and-background" className="inside-section">Introduction and Background</h3>
                    <p>Photo ID Matching in FaceTec SDKs be performed with very high accuracy due to the high level of detail in the FaceTec 3D FaceMap, enhanced ID Document Scan image selection, and algorithms that look beyond the obfuscation challenges of IDs like glare, anti-tampering lines, small/low quality photos, and quality issues related to worn IDs or old ID photos.</p>
                    <p>Features and Notes:</p>
                    <ul>
                      <li><p>The Photo ID Match process only succeeds if the User passes Liveness and the Live User matches the face present on the Photo ID.</p></li>
                      <li><p>FaceTec Device SDKs provide access to 3 high resolution photos of the Photo ID Document  via the <code>ZoomIDScanResult.idScanMetrics</code> result object.  These photos can be saved for auditing purposes and sent via Server-to-Server API to eKYC vendors for OCR, and/or document authenticity checks.  <Link to="/zoom-audit-trail">Find out more about retrieving these images here.</Link></p></li>
                      <li><p>Usage of the FaceTec Device SDK interface for the FaceTec 3D FaceMap and the ID Document Scan is required.</p></li>
                      <li><p>The full code for the Photo ID Match process is provided in the Sample App.</p></li>
                      <li><p>User’s 3D Face-to-Photo ID Match Levels (probabilities) are returned in the FaceTec Server SDK.</p></li>
                    </ul>
                  </div>

                  <div className={this.state.isMobile == true? "col-xs-12" :"col-xs-5 splitSectionBorder"}>
                    <br/>
                    <h3 id="match-levels" className="inside-section">Match Levels</h3>
                    <p>Here are the FaceTec Match Levels and associated probabilities:</p>

                    <ul>
                      <li><p>FaceTec Match Level 7 - 1/500,000 FAR</p></li>
                      <li><p>FaceTec Match Level 6 - 1/100,000 FAR</p></li>
                      <li><p>FaceTec Match Level 5 - 1/10,000 FAR</p></li>
                      <li><p>FaceTec Match Level 4 - 1/1,000 FAR</p></li>
                      <li><p>FaceTec Match Level 3 - 1/500 FAR</p></li>
                      <li><p>FaceTec Match Level 2 - 1/250 FAR</p></li>
                      <li><p>FaceTec Match Level 1 - 1/100 FAR</p></li>
                      <li><p>FaceTec Match Level 0 - Non-match</p></li>
                    </ul>

                    <p className="small">* The False Reject Rate is subject to dataset quality, style of ID, quality of capture, and particulars of the IDs.</p>
                  </div>
                </div>
              </section>

              <hr />

              <section>
                <h3 id="get-started-with-photo-id-match-identity-check" className="inside-section">Get Started with Photo ID Match</h3>
                <p>Sample Apps for each platform contain full examples, see sample app code for detailed information.</p>
              </section>

              <hr />

              <section>
                <h3 id="getting-started">Getting Started</h3>
                <p>To get started with Photo ID Matching, check out the PhotoIDMatchProcessor class in the Sample.</p>

                <p>The components of the solution are:</p>

                <ul>
                  <li><p>Your application retrieves the FaceTec 3D FaceMap and the FaceTec SDK ID Scan objects. The FaceTec 3D FaceMap and the FaceTec SDK ID Scan objects are proprietary and encrypted-by-default pieces of data that are only usable by the FaceTec Server SDK.</p></li>
                  <li><p>Your application retrieves the FaceTec SDK Audit Trail Images (images from the User Session) and ID Scan Front & Back (if applicable) Images.</p></li>
                  <li><p>Your application uploads the FaceTec 3D FaceMap and FaceTec ID Scan object to your secure webservice, passing these objects to the FaceTec Server SDK via the idCheck() API (/id-check in the FaceTec Server REST Sample Code).</p></li>
                  <li><p>The Match Level is returned along with other metrics, and the Customer App proceeds with business logic based on the results.</p></li>
                </ul>
              </section>

              <hr />

              <section>
                <h3 id="3d-facemap-info">FaceTec 3D FaceMaps</h3>
                <p>The FaceTec 3D FaceMap technology is relied upon by all core functions of the FaceTec SDK platform.</p>

                <p>FaceTec 3D FaceMaps are generated from every completed User Session. Additionally, FaceTec 3D FaceMaps are:</p>

                <ul>
                  <li><p><strong>Encrypted</strong>: This is required and enforced by the FaceTec SDK APIs.</p></li>
                  <li><p><strong>Proprietary</strong>: FaceTec 3D FaceMaps cannot be used by anything other than the FaceTec Server SDK.</p></li>
                  <li><p><strong>Created via a patented process</strong>: Users performing User Sessions from any device are using FaceTec’s patented interface to create FaceTec 3D FaceMaps.</p></li>
                  <li><p><strong>Cross-platform</strong>: FaceMaps from iOS, Android, or Browser can be used interchangeably.</p></li>
                  <li><p><strong>Data-rich</strong>: FaceTec 3D FaceMaps are created by processing (in most cases) upwards of 100 frames of data from the raw camera data.</p></li>
                  <li><p><strong>Future-proof and forward-compatible</strong>: FaceTec 3D FaceMaps created today are guaranteed to be able to leverage future FaceTec Matching Algorithm improvements.</p></li>
                  <li><p><strong>Not a Honeypot Risk</strong>: Liveness Data used for Liveness Detection is deleted from FaceMaps after each session.</p></li>
                  <li><p><strong>Flexible</strong>: FaceTec 3D FaceMaps can be stored as files, in databases, in blocks, on a server or on a device. Customer-specific encryption schemes can be applied in addition to FaceTec's built-in security mechanisms.</p></li>
                </ul>
              </section>

              <SDKSidebar menuType="main" title="Matching Guide" />

            </div>
          </div>
        </div>
      </div>
    );
  }

});



// WEBPACK FOOTER //
// ./src/js/components/screens/photo-id-match-guide.jsx